import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import * as batshit from '@yornaath/batshit';


export type CollaborativeStateDetails = {
  stateId: string;
  requiresCollaborativeAgreement: boolean;
  physicianSeatCapacity: number | null;
  requiresSupervisionMeeting: boolean;
  allowsStateExhibit: boolean;
};


export const getCollaborativeStateDetailsByIds = async (stateIds?: string[]) => restClient.request<{ data: CollaborativeStateDetails[] }>('/api/v1/collaborative_state/by_ids', {
  method: 'POST',
  data: {
    ids: stateIds,
  }
});


const collaborativeStateDetailsBatch = batshit.create({
  fetcher: async (stateIds: string[]) => {
    const response = await getCollaborativeStateDetailsByIds(stateIds.filter(Boolean));

    return response.data;
  },
  resolver: (response, key) => response?.find((item) => item.stateId === key),
  scheduler: batshit.windowScheduler(10)
});


export const getCollaborativeStateDetailsById = async (stateId: string) => collaborativeStateDetailsBatch.fetch(stateId);


export type UpdateCollaborativeStateDetailsParams = Pick<CollaborativeStateDetails, 'requiresCollaborativeAgreement' | 'physicianSeatCapacity' | 'requiresSupervisionMeeting' | 'allowsStateExhibit'>;
export const updateCollaborativeStateDetails = async (stateId: string, params: UpdateCollaborativeStateDetailsParams) => restClient.request<null>(`/api/v1/collaborative_state/${stateId}`, {
  method: 'PUT',
  data: snakecaseKeys(params)
});
